import mapValues from 'lodash/mapValues';
import flow from 'lodash/flow';
import flip from 'lodash/flip';
import * as DateTimeInterval from '../DateTimeInterval';
import * as TimeInterval from '../TimeInterval';
import * as WeekDay from '../WeekDay';
export const fromSchedule = (schedule = []) => {
    const map = {
        MONDAY: [],
        TUESDAY: [],
        WEDNESDAY: [],
        THURSDAY: [],
        FRIDAY: [],
        SATURDAY: [],
        SUNDAY: [],
    };
    schedule.forEach((item) => {
        breakScheduleItem(item).forEach(({ day, ...timeInterval }) => map[day].push(timeInterval));
    });
    return normalize(map);
};
const normalize = (weekMap) => mapValues(weekMap, TimeInterval.normalizeList);
const iterator = {
    ...WeekDay,
    distance: flip(WeekDay.distance),
};
const breakScheduleItem = flow(DateTimeInterval.fromScheduleItem, DateTimeInterval.breakInterval(iterator));
//# sourceMappingURL=WeekMap.js.map